import dayjs from "dayjs";
import { FC } from "react";
import { Link, useSearchParams } from "react-router-dom";
import DepartureCard from "../../components/scan/DepartureCard";
import ListState from "../../components/scan/ListState";
import DayPicker from "../../components/ui/datepicker/day/DayPicker";
import Table, { Row } from "../../components/ui/table";
import usePolling from "../../hooks/usePolling";
import useWindowSize from "../../hooks/useWindowResize";
import { getDepartures } from "../../services/Boarding.service";

const POLL_MS = 5000;

const columns = ["Nisja", "Linja", "Shitur", "Skanuar", "Nga nisje të tjera", "Pa skanuar", "Veprimet"];

const Departures: FC = () => {
  const [params, setParams] = useSearchParams();
  const date = params.get("date") ?? dayjs().format("YYYY-MM-DD");
  const { data, failed, reload } = usePolling(() => getDepartures(date).then((r) => r.data), POLL_MS, [date]);
  const { sm, md, lg } = useWindowSize();
  const phone = sm || md || lg;

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full sm:w-80">
        <DayPicker
          label="Data"
          numberOfMonths={1}
          date={dayjs(date).toDate()}
          onChangeDate={(day) =>
            day && setParams({ date: dayjs(day).format("YYYY-MM-DD") }, { replace: true })}
        />
      </div>
      {phone ? (
        <div className="flex flex-col gap-3">
          {data?.map((departure) => (
            <DepartureCard key={departure.tripId} departure={departure} date={date} />
          ))}
        </div>
      ) : (
        <Table titles={columns} style="hover" loading={!data && !failed}>
          {data?.map((departure) => {
            const route = `${departure.from} → ${departure.to}`;
            const time = dayjs(departure.departure).format("HH:mm");
            return (
              <Row
                key={departure.tripId}
                departure={time}
                line={<span className="block max-w-[14rem] truncate" title={route}>{route}</span>}
                sold={departure.sold}
                boarded={<strong>{departure.boarded}</strong>}
                fromOther={departure.boardedFromOtherDepartures}
                toBoard={departure.toBoard}
                actions={
                  <Link
                    to={`/scan/departures/${departure.tripId}/${date}`}
                    state={{ crumbs: ["Kontrolli i biletave", "Udhëtarët", time] }}
                    className="inline-flex min-h-[44px] items-center font-semibold text-primary"
                  >
                    Udhëtarët
                  </Link>
                }
              />
            );
          }) ?? []}
        </Table>
      )}
      <ListState
        loading={!data}
        failed={failed}
        empty={!!data && !data.length}
        emptyText="Nuk ka nisje me bileta për këtë datë"
        phone={phone}
        onRetry={reload}
      />
    </div>
  );
};

export default Departures;
